import { styled } from "styled-components";

export const AddCatButton = styled.button`
	background-color: #003a50;
	color: #ffffff;
	border: 1px solid #ffffff;
	border-radius: 0.6rem;
	display: flex;
	gap: 1rem;
	padding: ${(props) => (props.type === "small" ? ".5rem" : "1rem")};
	cursor: pointer;
	align-items: center;
	font-size: 16px;
	${(props) => (props.status ? "none" : "1px solid #B8C8CF")};
`;

export const SubsectionsHeader = styled(AddCatButton)`
	background-color: #ffffff;
	color: #003a50;
	border: 1px solid #b8c8cf;
	align-self: flex-start;
	font-weight: 500;
`;

export const SubSectionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const CategoryContainer = styled.div`
	display: flex;
	gap: 1rem;
	cursor: pointer;
	align-items: center;
	flex-wrap: wrap;
`;

export const ViewSubCategory = styled.button`
	color:  ${(props) => (props.type ? "#ff7373" : "#333")};
	background: ${(props) => (props.type ? "#ffeeee" : "#eff8f9")};
	border-radius: 0.5rem;
	padding: 0.3rem;
	font-size: 14px;
	display: flex;
	align-items: center;
	gap: 0.3rem;
`;

export const HeaderButton = styled(AddCatButton)`
	border: 1px solid #b8c8cf;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 0.6rem;
	color: #003a50;
	font-weight: 600;
	font-size: 20px;
	padding: 0.6rem;
	width: auto;
	align-self: flex-start;
`;

export const EditButton = styled(HeaderButton)`
	outline: none;
	border: none;
	background: #eff8f9;
	padding: 0.3rem;
	font-size: 12px;
	gap: 0.8rem;
`;

export const SubCategoryButton = styled(HeaderButton)`
	color: #555555;
	font-size: 14px;
	font-weight: 500;
	padding: 0.6rem 0.5rem 0.6rem 0.5rem;
`;

export const HeaderWrapper = styled.div`
	display: flex;
	gap: 1rem;
	margin-top: 1rem;
	flex-direction: column;

`;

export const SubContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin-top: 2rem;

	header {
		color: #333333;
		font-weight: 700;
	}

	div {
		display: flex;
		gap: 1rem;
	}
`;

export const SubCategoriesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
